module.exports = __webpack_public_path__ + "img/analysis.f249977d.svg";